@if (inventoryAction()) {
  <mat-toolbar class="header">
    <div class="back" (click)="goBack()" matTooltip="Atrás" matTooltipPosition="right">
      <mat-icon >arrow_back_ios_new</mat-icon>
    </div>
    <div>
      {{ title }}
    </div>
  </mat-toolbar>
  
  <div class="dialog-wrapper">
    @if(loading()) {
      <mat-spinner></mat-spinner>
    } @else {
      <div class="status-chips">
        <app-chip [color]="inventoryAction().status?.color" [text]="inventoryAction().status?.name"></app-chip>
      </div>
      <div class="transfer-row">
        <div class="warehouse-card">
          <div class="black" >Origen</div>
          <br>
          <div>{{inventoryAction().warehouse.name}}</div>
          <div class="warehouse-address">{{inventoryAction().warehouse.address}}</div>
        </div>
        <div class="icon-container">
          <i class="fas fa-arrow-right"></i>
        </div>
    
        <div class="warehouse-card">
          <div class="black">Destino</div>
          <br>
          <div>{{inventoryAction().target_warehouse.name}}</div>
          <div class="warehouse-address">{{inventoryAction().target_warehouse.address}}</div>
        </div>
      </div>
    
      <div class="transfer-table-wrapper display-desktop">
    
        <table class="transfer-table">
          <thead>
            <tr>
              <th>Producto</th>
              <th>{{ isCompleted ? 'Recibido' : 'Cantidad' }}</th>
              @if (isCompleted) {
                <th>Discrepancias</th>
              }
            </tr>
          </thead>
          <tbody>
            @for(inventory_action_product of inventoryAction().inventory_action_products; track inventory_action_product.id) {
              @let receivedProduct = getReceivedProduct(inventory_action_product.product_id);
              <tr>
                <td>
                  <div>
                    <div class="name">{{inventory_action_product.product.name}}</div>
                    <div class="code">{{inventory_action_product.product.code}}</div>
                  </div>
                </td>
                <td>
                  @if (isCompleted && receivedProduct) {
                    {{receivedProduct.quantity}} de {{inventory_action_product.quantity}} unidades
                  } @else {
                    {{inventory_action_product.quantity}} unidades
                  }
                </td>
                @if (isCompleted && receivedProduct) {
                  <td>
                    @if(inventory_action_product.quantity < receivedProduct.quantity) {
                      <div class="status-transfer missing">
                        {{inventory_action_product.quantity - receivedProduct.quantity}} faltantes
                      </div>
                    } @else if (inventory_action_product.quantity > receivedProduct.quantity) {
                      <div class="status-transfer missing">
                        {{receivedProduct?.quantity - inventory_action_product.quantity}} sobrantes
                      </div>
                    } @else {
                      <div class="status-transfer completed">
                        Sin discrepancias
                      </div>
                    }
                  </td>
                }
              </tr>
            }
            
          </tbody>
        </table>
      </div>

      <div class="products display-mobile">
        @for (inventory_action_product of inventoryAction().inventory_action_products; ; track inventory_action_product.id) {
          @let receivedProduct = getReceivedProduct(inventory_action_product.product_id);
          <div class="card product">
            <div class="card-content">
              <div class="card-details">
                <div class="row">
                  <span class="light">#{{inventory_action_product.product.code }}</span>
                </div>
                <div class="row title">
                  <span class="bold">{{inventory_action_product.product.name | human}}</span>
                </div>
                <div class="row">
                  <span>
                     @if (isCompleted && receivedProduct) {
                       {{receivedProduct.quantity}} de {{inventory_action_product.quantity}} unidades
                     } @else {
                       {{inventory_action_product.quantity}} unidades
                     }
                  </span>
                </div>
                <div class="row">
                  <span>
                    @if (isCompleted && receivedProduct) {
                      <td>
                        @if(inventory_action_product.quantity < receivedProduct.quantity) {
                          <div class="status-transfer missing">
                            {{inventory_action_product.quantity - receivedProduct.quantity}} faltantes
                          </div>
                        } @else if (inventory_action_product.quantity > receivedProduct.quantity) {
                          <div class="status-transfer missing">
                            {{receivedProduct?.quantity - inventory_action_product.quantity}} sobrantes
                          </div>
                        } @else {
                          <div class="status-transfer completed">
                            Sin discrepancias
                          </div>
                        }
                      </td>
                    }
                  </span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
     
      <app-document-works [order]="inventoryAction()" (load)="reloadInventoryAction()()"></app-document-works>
    }
    
  </div>
}

